// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__1cztV","header":"table_header__13KYe","modalHeader":"table_modalHeader__I8P2g"};